import * as React from 'react';
import { Image, LinkButton, Theme, UIHeading2, UIText1 } from '@cian/ui-kit';

import { IPromoBanner } from '../../../types/newbuildingBanners/promoBanner';
import { Banner } from '../Banner/Banner';
import { TBannerTheme } from '../utils/bannerTypeToTheme';

import * as styles from './MarketingBanner.css';

interface IMarketingBannerProps extends IPromoBanner {
  onClick(): void;
  theme: TBannerTheme;
}

const DEFAULT_ACTION_TEXT = 'Открыть';

export const MarketingBanner = ({ action, imageUrl, subtitle, title, theme, onClick }: IMarketingBannerProps) => {
  return (
    <Banner
      onClick={onClick}
      theme={theme}
      title=""
      imageUrl={null}
      labels={null}
      subtitle=""
      linkUrl={action.link}
      customContent={
        <div className={styles['custom-content']}>
          {imageUrl && (
            <div className={styles['image']}>
              <Image src={imageUrl} width="197px" height="46px" objectFit="contain" />
            </div>
          )}
          <div className={styles['description']}>
            <div className={styles['title']}>
              <UIHeading2 color="current_color">{title}</UIHeading2>
            </div>
            <div className={styles['subtitle']}>
              <UIText1 color="current_color">{subtitle}</UIText1>
            </div>
          </div>
        </div>
      }
      footer={
        <Theme theme="colored">
          <LinkButton href={action.link} target="_blank" onClick={onClick} fullWidth={true}>
            {action.title || DEFAULT_ACTION_TEXT}
          </LinkButton>
        </Theme>
      }
    />
  );
};
